<tt-page *ngIf="page" class="col-xs-12 sp-0 height-full">
    <tt-card class="col-xs-12 p-2">
        <tt-page-heading *ngIf="page.projects_heading" [ttModel]="page.projects_heading"></tt-page-heading>
        <div class="projects__statuses">
            <tt-button
                *ngFor="let option of statusOptions"
                [ttText]="option.label"
                [ttType]="page.bg_projects_activestatus === option.id ? 'primary' : 'secondary'"
                (ttClick)="selectStatus(option.id)">
            </tt-button>
        </div>
    </tt-card>

    <div class="col-xs-12 sp-0 projects__filters">
        <tt-card class="col-xs-12 col-md-4 p-2">
            <tt-date-range
                ttLabel="date_fom_tom"
                ttRememberId="w_projects"
                [ttModel]="dateRange"
                (ttModelChange)="onDateRangeChanged($event)">
            </tt-date-range>
            <tt-input ttLabel="projects_searchtext" ttRememberId="w_projects.searchtext" [(ttModel)]="page.searchtext" (ttModelChange)="onSearchTextChanged($event)" ttShowClearButton>
                <ng-container buttons>
                    <tt-form-field-button ttId="search" ttIcon="fas fa-search" ttType="primary" (ttClick)="search()"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-button ttText="projects_new" (ttClick)="goToNewProject()" ttTextAlign="left" ttIcon="fas fa-plus"></tt-button>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-2">
            <tt-select
                ttLabel="businessco"
                ttRememberId="w_projects.businessco_no"
                [(ttModel)]="page.businessco_no"
                (ttModelChange)="onFilterChanged()"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name">
            </tt-select>
            <tt-search-multi-select
                ttLabel="project_keynos"
                ttRememberId="w_projects.project_keynos"
                ttModelSetting="stringId"
                [ttSingleSelection]="false"
                ttSeparatorKey=","
                [(ttModel)]="page.project_keynos"
                (ttModelChange)="onFilterChanged()"
                [ttData]="searchProjectNames"
                ttDataId="item_id"
                ttDataName="item_name">
            </tt-search-multi-select>
        </tt-card>
    </div>

    <tt-list *ngIf="!isTablet" class="col-xs-12 sp-0 flex-1" [ttData]="projects"></tt-list>
    <tt-grid *ngIf="isTablet && grid && page.bg_projects_activestatus !== 'ECONOMY'" class="col-xs-12 p-2 flex-1" [(ttOptions)]="grid"></tt-grid>
    <tt-grid *ngIf="isTablet && gridEconomy && page.bg_projects_activestatus === 'ECONOMY'" class="col-xs-12 p-2 flex-1" [(ttOptions)]="gridEconomy"></tt-grid>
</tt-page>
